import { render, staticRenderFns } from "./DeleteLabel.vue?vue&type=template&id=c522eb3e&scoped=true&"
import script from "./DeleteLabel.vue?vue&type=script&lang=js&"
export * from "./DeleteLabel.vue?vue&type=script&lang=js&"
import style0 from "./DeleteLabel.vue?vue&type=style&index=0&id=c522eb3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c522eb3e",
  null
  
)

export default component.exports